var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column-layout" },
    [
      _c(
        "el-form",
        {
          ref: "adoptedDeviceInfo",
          attrs: { model: _vm.adoptedDevice, rules: _vm.adoptedDeviceRules }
        },
        [
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("分类信息")]),
            _vm._v(" "),
            _vm.adoptedDevice.skuId == -1 || _vm.adoptedDevice.skuId == null
              ? _c(
                  "a",
                  {
                    staticClass: "swb-btn-link",
                    on: {
                      click: function($event) {
                        _vm.selectCatInfo()
                      }
                    }
                  },
                  [_vm._v("选择")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center " }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("分类名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "goodsCatName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.adoptedDevice.goodsCatName,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "goodsCatName", $$v)
                          },
                          expression: "adoptedDevice.goodsCatName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("品牌名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "goodsBrandName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.adoptedDevice.goodsBrandName,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "goodsBrandName", $$v)
                          },
                          expression: "adoptedDevice.goodsBrandName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("商品信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("组装件")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "asmblAccFlag" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: {
                            disabled:
                              _vm.adoptedDevice.assetDefId != null &&
                              _vm.adoptedDevice.assetDefId != -1
                          },
                          model: {
                            value: _vm.adoptedDevice.asmblAccFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.adoptedDevice, "asmblAccFlag", $$v)
                            },
                            expression: "adoptedDevice.asmblAccFlag"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticClass: "radio mr10",
                              attrs: { label: true }
                            },
                            [_vm._v("是")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            { staticClass: "radio", attrs: { label: false } },
                            [_vm._v("否")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          disabled:
                            _vm.adoptedDevice.skuId != -1 &&
                            _vm.adoptedDevice.skuId != null
                        },
                        model: {
                          value: _vm.adoptedDevice.name,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "name", $$v)
                          },
                          expression: "adoptedDevice.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("型号")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "model" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          disabled:
                            _vm.adoptedDevice.skuId != -1 &&
                            _vm.adoptedDevice.skuId != null
                        },
                        model: {
                          value: _vm.adoptedDevice.model,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "model", $$v)
                          },
                          expression: "adoptedDevice.model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("规格")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "fixedSpec" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          disabled:
                            _vm.adoptedDevice.skuId != -1 &&
                            _vm.adoptedDevice.skuId != null
                        },
                        model: {
                          value: _vm.adoptedDevice.fixedSpec,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "fixedSpec", $$v)
                          },
                          expression: "adoptedDevice.fixedSpec"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("质保期(月)")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "wrntPeriod" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: {
                          type: "number",
                          disabled:
                            _vm.adoptedDevice.skuId != -1 &&
                            _vm.adoptedDevice.skuId != null
                        },
                        model: {
                          value: _vm.adoptedDevice.wrntPeriod,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "wrntPeriod", $$v)
                          },
                          expression: "adoptedDevice.wrntPeriod"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("价格信息")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "simple-form" },
            [
              _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("税率")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value " },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "taxRate" } },
                      [
                        _c("el-input", {
                          staticClass: "width-2x ",
                          attrs: { type: "number" },
                          on: { blur: _vm.changeNtxPrice },
                          model: {
                            value: _vm.adoptedDevice.taxRate,
                            callback: function($$v) {
                              _vm.$set(_vm.adoptedDevice, "taxRate", $$v)
                            },
                            expression: "adoptedDevice.taxRate"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-tips" }, [_vm._v("%")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.bizAreaList.length <= 0 || _vm.adoptedDevice.contractEnded
                ? [
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("含税价")])
                      ]),
                      _vm._v(" "),
                      !_vm.adoptedDevice.contractEnded
                        ? _c(
                            "div",
                            { staticClass: "form-value " },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "price" } },
                                [
                                  _c("el-input", {
                                    staticClass: "width-2x ",
                                    attrs: {
                                      type: "number",
                                      disabled:
                                        _vm.adoptedDevice.skuId != -1 &&
                                        _vm.adoptedDevice.skuId != null
                                    },
                                    on: { blur: _vm.changePrice },
                                    model: {
                                      value: _vm.adoptedDevice.price,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adoptedDevice,
                                          "price",
                                          $$v
                                        )
                                      },
                                      expression: "adoptedDevice.price"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-tips" }, [
                                    _vm._v("元")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "form-value " },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "price" } },
                                [
                                  _c("el-input", {
                                    staticClass: "width-2x ",
                                    attrs: { type: "number" },
                                    on: { blur: _vm.changePrice },
                                    model: {
                                      value: _vm.adoptedDevice.price,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adoptedDevice,
                                          "price",
                                          $$v
                                        )
                                      },
                                      expression: "adoptedDevice.price"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-tips" }, [
                                    _vm._v("元")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v("未税价")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "price2" } },
                            [
                              _c("el-input", {
                                staticClass: "width-2x bottom-line",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.adoptedDevice.ntxPrice,
                                  callback: function($$v) {
                                    _vm.$set(_vm.adoptedDevice, "ntxPrice", $$v)
                                  },
                                  expression: "adoptedDevice.ntxPrice"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-tips" }, [
                                _vm._v("元")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("经营区域信息")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "swb-btn-link",
                on: {
                  click: function($event) {
                    _vm.selectBizAreaInfo()
                  }
                }
              },
              [_vm._v("选择")]
            )
          ]),
          _vm._v(" "),
          _vm.adoptedDevice.id == null
            ? [
                _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.bizAreaList,
                          border: "",
                          "tooltip-effect": "dark"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "bizAreaName",
                            label: "名称"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "bizAreaCode",
                            label: "编码"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "110",
                            prop: "price",
                            label: "含税价"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-input", {
                                        on: {
                                          change: function($event) {
                                            _vm.priceChange(scope.$index)
                                          }
                                        },
                                        model: {
                                          value: scope.row.price,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "price",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "scope.row.price"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "110",
                            prop: "ntxPrice",
                            label: "未税价"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(" " + _vm._s(scope.row.ntxPrice))
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "110",
                            prop: "bizFormName",
                            label: "经营业态"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.id != null
                                    ? _c("span", [
                                        _vm._v(" " + _vm._s(scope.row.ntxPrice))
                                      ])
                                    : _c(
                                        "span",
                                        [
                                          _vm._l(
                                            scope.row.bizFormList,
                                            function(bizForm, index) {
                                              return scope.row.bizFormList !=
                                                null &&
                                                scope.row.bizFormList.length > 0
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "swb-tags swb-tags-success mr5"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            bizForm.bizFormName
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            }
                                          )
                                        ],
                                        2
                                      )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "left", label: "操作" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.removeAreaPrice(scope.$index)
                                        }
                                      }
                                    },
                                    [_vm._v("移除")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.setAreaFrom(scope.$index)
                                        }
                                      }
                                    },
                                    [_vm._v("设置经营业态")]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _c("div", { staticClass: "simple-form" }, [
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("代码")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value " },
                      [
                        _c("el-form-item", { attrs: { prop: "name" } }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.adoptedDevice.bizAreaCode))
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("名称")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value" },
                      [
                        _c("el-form-item", { attrs: { prop: "fixedSpec" } }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.adoptedDevice.bizAreaName))
                          ])
                        ])
                      ],
                      1
                    )
                  ])
                ])
              ],
          _vm._v(" "),
          _vm.bizAreaList.length <= 0
            ? [
                _c("div", { staticClass: "content-caption dashed" }, [
                  _c("span", [_vm._v("经营业态信息")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "swb-btn-link",
                      on: {
                        click: function($event) {
                          _vm.selectBizFormInfo()
                        }
                      }
                    },
                    [_vm._v("选择")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "simple-form" }, [
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("名称")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-value" },
                      [
                        _vm.adoptedDevice.id != null
                          ? _c("el-form-item", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.adoptedDevice.bizFormName))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.adoptedDevice.id == null
                          ? _c(
                              "el-form-item",
                              [
                                _vm._l(_vm.bizFormList, function(
                                  bizForm,
                                  index
                                ) {
                                  return _vm.bizFormList != null &&
                                    _vm.bizFormList.length > 0
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "swb-tags swb-tags-success mr5"
                                          },
                                          [_vm._v(_vm._s(bizForm.bizFormName))]
                                        )
                                      ]
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("其他")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("星级")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "favorLevel" } },
                    [
                      _c("el-rate", {
                        model: {
                          value: _vm.adoptedDevice.favorLevel,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "favorLevel", $$v)
                          },
                          expression: "adoptedDevice.favorLevel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("到货天数")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "arriveDays" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: { type: "number" },
                        model: {
                          value: _vm.adoptedDevice.arriveDays,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "arriveDays", $$v)
                          },
                          expression: "adoptedDevice.arriveDays"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("备注")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "memo" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x",
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入备注信息"
                        },
                        model: {
                          value: _vm.adoptedDevice.desc,
                          callback: function($$v) {
                            _vm.$set(_vm.adoptedDevice, "desc", $$v)
                          },
                          expression: "adoptedDevice.desc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87faa190", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87faa190","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/AdoptedDeviceSave.vue
// module id = 3109
// module chunks = 0